import { cn } from "@/lib/utils"
import { useCandidateVisibility } from "../data/use-candidate-visibility"

export type HiringConsiderationToggleProps = {
  checked: boolean
  disabled?: boolean
  onCheckedChange: (next: boolean) => void
  className?: string
}

/** Presentation-only switch; connected wrapper owns Convex. */
export function HiringConsiderationToggleControl({
  checked,
  disabled = false,
  onCheckedChange,
  className,
}: HiringConsiderationToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={
        checked
          ? "Open to work — turn off to hide from talent search"
          : "Not open to work — turn on so verified companies can discover you"
      }
      disabled={disabled}
      className={cn(
        "mkt-hiring-toggle",
        checked && "mkt-hiring-toggle--on",
        className,
      )}
      onClick={() => onCheckedChange(!checked)}
    >
      <span className="mkt-hiring-toggle__track" aria-hidden>
        <span className="mkt-hiring-toggle__thumb" />
      </span>
      <span className="mkt-hiring-toggle__label">Open to work</span>
    </button>
  )
}

/** Candidate desk control for recruiter discovery (`candidateVisibility`). */
export function HiringConsiderationToggle({
  className,
}: {
  className?: string
}) {
  const { role, openToHiring, deletionRequested, pending, setOpenToHiring } =
    useCandidateVisibility()

  if (role !== "seeker") return null

  return (
    <HiringConsiderationToggleControl
      checked={openToHiring}
      disabled={pending || deletionRequested}
      onCheckedChange={(next) => void setOpenToHiring(next)}
      className={className}
    />
  )
}
